export const appVersion = '1.3.0';

// password configuration
export const specialChars = '!@#$%& *()][}{|,:;<>/?+-_=';
export const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const name = 'Urząd Gminy Długołęka';
export const description = 'Portal Elektronicznych Usług Publicznych';

export const topRightUELogoEnabled = true;

// export const appLogoTopUrl = '/img/Herb_Polski.svg';
// export const appLogoBottomUrl = '/img/icons/godlo-12.svg';

export const appLogoTopUrl = '/img/ug_dlugoleka/logo.png';
export const appLogoBottomUrl = '/img/ug_dlugoleka/herb.png';

export const showFooterEULogotypes = true;

export const applicationSubmittedTo = 'Wójt Gminy Długołęka';
